export default [
  {
    path: '/ai',
    name: 'ai',
    component: () => import('@/views/menu/ai/ai.vue'),
    meta: {
      pageTitle: 'تولید محتوا با هوش مصنوعی',
      action: 'show',
      resource: 'AiManager',
    },
  },
]
